// extracted by mini-css-extract-plugin
export default {"price-adjustment":"price-adjustment-f2da","slashed-text":"slashed-text-3a08","sm-spacing-left":"sm-spacing-left-312d","price-change-container":"price-change-container-39aa"};